<template>
    <BaseWidget :title="widget.title" :title-url="widget.titleUrl">
        <div class="inset-0 flex justify-center align-center">
            <transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
            >
                <div v-if="is_present">
                    <div class="flex gap-x-2">
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-12 w-12 text-lime-400 icon icon-tabler icon-tabler-checks"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                stroke-width="2"
                                stroke="currentColor"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M7 12l5 5l10 -10"></path>
                                <path d="M2 12l5 5m5 -5l5 -5"></path>
                            </svg>
                        </div>
                    </div>
                </div>
                <AppButton v-else desired-action element="button" type="button" @click="submit">
                    {{ widget.content.text_button }}
                    <span v-if="isLoading" class="ml-1 btn-spinner"></span>
                </AppButton>
            </transition>
            <div v-if="!isOnline">Is offline</div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    name: 'SelfAttendanceStudentWidget',
    components: {
        AppButton,
        BaseWidget,
    },
};
</script>
<script setup>
import { ref, watch } from 'vue';
import { useAxios } from '@vueuse/integrations/useAxios';
import { useNetwork } from '@vueuse/core';

const props = defineProps({
    widget: {
        required: true,
        type: Object,
    },
});

const is_present = ref(props.widget.content.is_present);

const { execute, isLoading, data } = useAxios(props.widget.content.url, { method: 'POST' }, { immediate: false });
const { isOnline } = useNetwork();
watch(data, (newVal) => {
    if (newVal.status === 'ok') {
        is_present.value = true;
    }
});
function submit() {
    execute();
}
</script>
